// extracted by mini-css-extract-plugin
module.exports = {"container":"history-page_container__1TtgB"};